var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperationalDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/convertshape-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    d: "M9 14.15V16.85C9 19.1 8.1 20 5.85 20H3.15C0.9 20 0 19.1 0 16.85V14.15C0 11.9 0.9 11 3.15 11H5.85C8.1 11 9 11.9 9 14.15Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M15.5 9C17.9853 9 20 6.98528 20 4.5C20 2.01472 17.9853 0 15.5 0C13.0147 0 11 2.01472 11 4.5C11 6.98528 13.0147 9 15.5 9Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.78 20C12.51 20 12.26 19.85 12.13 19.62C12 19.38 12 19.1 12.14 18.86L13.11 17.24C13.32 16.88 13.78 16.77 14.14 16.98C14.5 17.19 14.61 17.65 14.4 18.01L14.22 18.31C16.69 17.67 18.51 15.43 18.51 12.77C18.51 12.36 18.85 12.02 19.26 12.02C19.67 12.02 20 12.36 20 12.78C20 16.76 16.76 20 12.78 20Z",
    fill: "#7C7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.75 7.97C0.34 7.97 0 7.64 0 7.22C0 3.24 3.24 0 7.22 0C7.5 0 7.74 0.15 7.88 0.38C8.01 0.62 8.01 0.9 7.87 1.14L6.9 2.75C6.68 3.11 6.22 3.23 5.87 3.01C5.51 2.8 5.4 2.34 5.61 1.98L5.79 1.68C3.33 2.32 1.5 4.56 1.5 7.22C1.5 7.64 1.16 7.97 0.75 7.97Z",
    fill: "#7C7C7C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationalDisabled);
export default __webpack_public_path__ + "static/media/operationalDisabled.d8c794bb207a1e3b86ac59ee8c679dc8.svg";
export { ForwardRef as ReactComponent };